// Angular Imports
import { Component, Input } from '@angular/core'
import { CommonModule } from '@angular/common'
// Shared Imports
import { ECountry } from '@shared/models'

@Component({
	selector: 'app-flag-country',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './flag-country.component.html',
	styleUrls: ['./flag-country.component.scss'],
})
export class FlagCountryComponent {
	@Input() country: ECountry = ECountry.unknown
	@Input() width: number = 100
	@Input() height: number = 100

	readonly ECountry = ECountry
}
